export default __webpack_public_path__ + "7b1623d649394a214df52644f0f7cd9b.png";